import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../schema.dexie";
import { listarAlimentos } from "../db/queries";
import type { StatusAlimento } from "../types";
import { StatusBadge } from "../ui/StatusBadge";
import { FoodPhoto } from "../ui/FoodPhoto";
import { IndicadorEvolucao } from "../ui/IndicadorEvolucao";

type Filtro = "todos" | StatusAlimento;

const FILTROS: { v: Filtro; r: string }[] = [
  { v: "todos", r: "todos" },
  { v: "seguro", r: "seguros" },
  { v: "em_teste", r: "em teste" },
  { v: "recusado", r: "recusados" },
  { v: "nao_oferecido", r: "não oferecidos" },
];

const FILTROS_VALIDOS = new Set<Filtro>(FILTROS.map((f) => f.v));

export function Biblioteca() {
  const nav = useNavigate();
  // filtro vem da URL (?status=…) — assim os indicadores da Hoje abrem já filtrado
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("status") as Filtro | null;
  const filtro: Filtro = param && FILTROS_VALIDOS.has(param) ? param : "todos";
  const setFiltro = (f: Filtro) =>
    setSearchParams(f === "todos" ? {} : { status: f }, { replace: true });
  const alimentos = useLiveQuery(() => listarAlimentos()) ?? [];
  const ofertas = useLiveQuery(() => db.oferta.toArray()) ?? [];

  const lista =
    filtro === "todos" ? alimentos : alimentos.filter((a) => a.status === filtro);

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <div className="row-entre">
        <h1 className="tela-titulo">biblioteca</h1>
        <Link to="/biblioteca/novo" className="btn btn-primario">
          ➕ novo
        </Link>
      </div>

      <div className="chips" style={{ marginBottom: "var(--s4)" }}>
        {FILTROS.map((f) => (
          <button
            key={f.v}
            className="chip"
            style={
              filtro === f.v
                ? { background: "var(--accent-suave-bg)", color: "var(--accent-forte)", borderColor: "var(--accent-suave-borda)" }
                : undefined
            }
            onClick={() => setFiltro(f.v)}
          >
            {f.r}
          </button>
        ))}
      </div>

      {lista.length === 0 ? (
        <div className="vazio">
          <span className="emoji" aria-hidden>
            🍎
          </span>
          {alimentos.length === 0
            ? "nenhum alimento ainda. comece cadastrando um."
            : "nada neste filtro."}
        </div>
      ) : (
        <div className="lista-cards">
        {lista.map((a) => (
          <button
            className="card linha-alimento"
            key={a.id}
            onClick={() => nav(`/alimento/${a.id}`)}
          >
            <FoodPhoto fotoId={a.fotos[0]} nome={a.nome} categoria={a.categoria} />
            <div className="crescer">
              <div className="row-entre">
                <div className="nome">{a.nome}</div>
                <StatusBadge status={a.status} />
              </div>
              {a.marca_produto && <div className="meta">{a.marca_produto}</div>}
              <IndicadorEvolucao alimentoId={a.id} ofertas={ofertas} />
            </div>
          </button>
        ))}
        </div>
      )}
    </main>
  );
}
